import { LocalStorageDataModel } from "../../constants/local-storage-data-model";
import NewCryptoJs from "../../utils/crypto";
import { Env } from "../../utils/globalUtilities";
import axios from "axios";
const crypto = new NewCryptoJs();

const unauthorizedCode = [401];
const bypassErrorToComponentCode = ["FAILURE"];
// const generateMachineId = () => {
//   return Math.random().toString(36).slice(2, 15);
// };

export const LearningBaseService = axios.create({
  timeout: 60000,
  baseURL: Env().REACT_APP_NODE_LEARNING_URL,
});

LearningBaseService.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem(LocalStorageDataModel.AUTH_TOKEN);
    let machineid = localStorage.getItem(LocalStorageDataModel.MACHINE_ID_NEW);
    let contenttoken = localStorage.getItem(
      LocalStorageDataModel.CONTENT_TOKEN
    );
    // let doEncrypt = localStorage.getItem("isDev") ? false : true;
    // if (config?.headers?.hasOwnProperty("encrypt")) {
    //   doEncrypt = config?.headers?.encrypt;
    // }
    config.headers = {
      refreshtoken: sessionStorage.getItem("refreshToken") || "",
      machineid: machineid,
      // encrypt: doEncrypt,
    };

    // if (doEncrypt) {
    //   config.data = {
    //     encodedPayload: crypto.encrypt(JSON.stringify(config.data)),
    //   };
    // }

    if (token) {
      config.headers = {
        ...config.headers,
        taxmannauthorization: token,
        contenttoken: contenttoken,
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

LearningBaseService.interceptors.response.use(
  (response) => {
    if (response?.config?.headers?.encrypt) {
      const data = JSON.parse(crypto.decrypt(response?.data?.data));
      response.data.data = data;
    }
    return response;
  },
  (error) => {
    const { response } = error;
    if (bypassErrorToComponentCode.includes(response?.data?.ResponseType)) {
      return response;
    }
    if (response && unauthorizedCode.includes(response.status)) {
    }
    return Promise.reject(error);
  }
);
